import React, { Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';

import { TOOL_BUTTON_NAMES } from 'constants/cloud-admin';
import { isAdminCurrentProductSelector, currentTabSelector } from 'selectors';
import { selectActiveTool } from 'selectors/cloud-admin';

import LoadingDefault from 'components/loading';
import AdminMarketing from './admin-marketing';

// `components/loading` is an untyped .js module; TS infers `className` as required. Loosen at this boundary.
const Loading = LoadingDefault as React.ComponentType<{ message?: string; className?: string }>;

interface TableComponentProps {
  product: string;
}

const tableToDisplay: Record<string, React.ComponentType<TableComponentProps>> = {
  [TOOL_BUTTON_NAMES.USERS]: lazy(() => import('./users-table')),
  [TOOL_BUTTON_NAMES.INVITES]: lazy(() => import('./invites-table')),
  [TOOL_BUTTON_NAMES.REPORTS]: lazy(() => import('./reports')),
  [TOOL_BUTTON_NAMES.SETTINGS]: lazy(() => import('./settings')),
  [TOOL_BUTTON_NAMES.CUSTOM_FIELDS]: lazy(() => import('./custom-fields')),
  [TOOL_BUTTON_NAMES.SHARED]: lazy(() => import('./shared-computer/shared-computer-table')),
  [TOOL_BUTTON_NAMES.FACS_WORKFLOW_MANAGER_LICENSES]: lazy(
    () => import('./facs-workflow-manager-license/table'),
  ),
};

const SelectedTabContent = (): React.ReactElement => {
  // Selectors are built from lodash `get` and resolve as `unknown`; narrow at this boundary.
  const selectedToolName = useSelector(selectActiveTool) as string;
  const selectedTab = useSelector(currentTabSelector) as string;
  const isAdminCurrentProduct = useSelector(isAdminCurrentProductSelector);

  const TableComponent = !isAdminCurrentProduct ? AdminMarketing : tableToDisplay[selectedToolName];
  return (
    <Suspense fallback={<Loading />}>
      <TableComponent product={selectedTab} />
    </Suspense>
  );
};

export default SelectedTabContent;
